<template>
  <div class="table__scroll__x is-size-7">
    <table class="table is-striped is-bordered">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th>
            <a
              class="button is-size-7"
              :class="isCheckedHerbApplied ? '' : 'is-primary'"
              @click="applyCheckedHerb">
              {{ isCheckedHerbApplied ? '解除' : '絞込' }}
            </a>
          </th>
          <th></th>
          <th>
            <a
              class="button is-size-7 is-primary"
              @click="clearCheckedHerbList">
              クリア
            </a>
          </th>
          <th class="has-text-centered is-vcentered" v-for="herb in visibleHerbList" :key="herb">
            <input
              type="checkbox"
              @change="clickHerb($event)"
              :checked="checkedHerbList.includes(herb)"
              :name="herb">
          </th>
        </tr>
        <tr>
          <th>
            <a
              class="button is-size-7 is-primary"
              @click="clearCheckedKanpoList">
              クリア
            </a>
          </th>
          <th>
            <a
              class="button is-size-7 is-primary"
              @click="clearWeightInptedList">
              クリア
            </a>
          </th>
          <th>
            <a
              class="button is-size-7"
              :class="isNonZeroHerbApplied ? '' : 'is-primary'"
              @click="toggleIsNonZeroHerbApplied">
              {{ isNonZeroHerbApplied ? '全て' : '０除' }}
            </a>
          </th>
          <td></td>
          <td></td>
          <td class="has-text-right" v-for="herb in visibleHerbList" :key="herb">
            {{ Math.round(herbWeightList[herb] * 100) / 100 }}
          </td>
        </tr>
        <tr>
          <th class="has-text-centered">
            <a
              class="button is-size-7"
              :class="isCheckedKanpoApplied ? '' : 'is-primary'"
              @click="applyCheckedKanpo">
              {{ isCheckedKanpoApplied ? '解除' : '適用' }}
            </a>
          </th>
          <th class="has-text-centered">グラム</th>
          <th class="has-text-right">番号</th>
          <th>漢方名</th>
          <th>生薬数</th>
          <th v-for="herb in visibleHerbList" :key="herb">{{ herb }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="kanpo in sortedKanpoList" :key="`${kanpo.Maker}-${kanpo.No}`">
          <td class="has-text-centered">
            <input
              type="checkbox"
              @change="clickList($event)"
              :checked="checkedKanpoList.includes(kanpo.id)"
              :name="kanpo.id">
          </td>
          <td class="has-text-centered">
            <input
              type="text"
              size=5
              :value="weightInptedList[`${kanpo.Maker}-${kanpo.No}`]"
              @input="setWeightInptedList($event, `${kanpo.Maker}-${kanpo.No}`)"
            />
          </td>
          <td class="has-text-right">{{ kanpo.Maker + '-' + kanpo.No }}</td>
          <td>{{ kanpo.name }}</td>
          <td class="has-text-right">{{ Object.keys(kanpo).length - 4 }}</td>
          <td class="has-text-right" v-for="herb in visibleHerbList" :key="herb">
            {{ kanpo[herb] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import firestore from '../firebase/firestore'
import { mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState('List', [
      'kanpoList',
      'checkedKanpoList',
      'herbList',
      'checkedHerbList',
      'weightInptedList',
      'isCheckedKanpoApplied',
      'isCheckedHerbApplied',
      'isNonZeroHerbApplied',
    ]),
    ...mapGetters('List', [
      'visibleHerbList',
      'herbWeightList',
    ]),
    sortedKanpoList() {
      return this.visibleKanpoList.slice().sort((kanpoA, kanpoB) => {
        if (kanpoA.No - kanpoB.No === 0) {
          if (kanpoA.Maker < kanpoB.Maker) return -1
          if (kanpoA.Maker > kanpoB.Maker) return 1
          return 0
        } else {
          return kanpoA.No - kanpoB.No
        }
      })
    },
    visibleKanpoList() {
      if (this.kanpoList.length == 0) return this.kanpoList

      if (!this.isCheckedKanpoApplied && !this.isCheckedHerbApplied) return this.kanpoList


      let checkedKanpoList = []
      if (this.isCheckedKanpoApplied) {
        checkedKanpoList = this.kanpoList.filter(l => this.checkedKanpoList.includes(l.id))
      } else {
        checkedKanpoList = this.kanpoList
      }

      if (this.isCheckedHerbApplied) {
        return  checkedKanpoList.filter(ckl => this.checkedHerbList.every(checkedHerb => {
          return Object.keys(ckl).includes(checkedHerb)
        }))
      } else {
        return checkedKanpoList
      }
    },
  },
  methods: {
    ...mapMutations('List', [
      'toggleIsNonZeroHerbApplied',
      'clearCheckedKanpoList',
      'clearWeightInptedList',
      'clearCheckedHerbList',
    ]),
    clickList(e) {
      this.$store.commit('List/updateKanpoList', e)
    },
    applyCheckedKanpo(e) {
      this.$store.commit('List/toggleIsCheckedKanpoApplied', e)
    },
    clickHerb(e) {
      this.$store.commit('List/updateHerbList', e)
    },
    applyCheckedHerb(e) {
      this.$store.commit('List/toggleIsCheckedHerbApplied', e)
    },
    setWeightInptedList(event, makerNum) {
      this.$store.commit('List/setWeightInptedList', { event, makerNum })
    },
    uniq(array) {
      const knownElements = new Map()
      for (const elem of array) {
        knownElements.set(elem, true)
      }
      return Array.from(knownElements.keys());
    },
  },
  mounted () {
    firestore.collection('list').get().then((querySnapshot) => {
      let kl = []
      let hl = []
      querySnapshot.forEach((doc) => {
        const herbs = Object.keys(doc.data()).filter(h => h != 'name')
        hl = [...new Set([...hl, ...herbs])]
        kl.push({id: doc.id, ...doc.data()})
      })
      this.$store.commit('List/setKanpoList', kl)
      this.$store.commit('List/setHerbList', hl)
    })
  },
  filters: {
  }
}
</script>

<style lang='scss' scoped>
@import '../../node_modules/bulma/bulma.sass';
@import '../assets/mystyles.scss';
</style>
